import { ReportKind } from "common/interfaces/ReportKind";
import { getJsonMasters } from "./common";

export const getReportKinds = async () =>
  await getJsonMasters<ReportKind>("report_kinds");
